// extracted by mini-css-extract-plugin
export default {"DeveloperList":"DeveloperList_DeveloperList__q9INI","name":"DeveloperList_name__qld94","type":"DeveloperList_type__8ljLR","phone":"DeveloperList_phone__MlYjP"};